import { useGoogleLogin } from '@react-oauth/google';
import { useEffect } from 'react';
import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { telegramLoginGoogle,linkTelegramToUser } from '../composables/fetchAPI'; // Import the function

export default function LoginAtTelegram() {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const tgId = new URLSearchParams(window.location.search).get('tg_id');
      const accessToken = tokenResponse.access_token;

      if (!tgId) {
        toast.error('Telegram ID not found in URL');
        return;
      }

      try {
        // Call the telegramLoginGoogle function
        const response = await telegramLoginGoogle(tgId, accessToken);
        // console.log('Telegram Login Response:', response); // Log the response

        if (response.status === 'not_linked') {
          // Handle the case where Telegram ID is not linked
          try {
            const linkResponse = await linkTelegramToUser({
              telegramId: tgId,
              telegramFirstname: response.user.first_name,
              // telegramLastname: response.user.last_name,
            });
            // console.log('Link Telegram Response:', linkResponse); // Log the link response
            toast.success('Telegram ID successfully linked to user!');
          } catch (linkError) {
            console.error('Failed to link Telegram ID:', linkError);
            toast.error('Failed to link Telegram ID to user.');
          }
        } else {
          toast.success('Telegram login successful!');
        }
      } catch (error) {
        console.error('Telegram Login Error:', error);
        toast.error('Failed to login Telegram with Google');
      }

      // Redirect back to Telegram with a success message
      window.location.href = `https://t.me/wethaiinvestbot?startapp=hello`;
    },
    onError: (err) => {
      console.error('Google Login Error:', err);
      toast.error('Login failed, please try again.');
    },
    scope: "https://www.googleapis.com/auth/youtube.readonly",
    flow: "implicit",
  });

  useEffect(() => {
    login(); // เรียกอัตโนมัติ
  }, []);

  return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-black text-gray-100">

    <Toaster />
      {/* Jiggle animation style only for this page */}
      <style>
        {`
          @keyframes jiggle {
            0%, 100% { transform: rotate(-8deg) scale(1.05); }
            20% { transform: rotate(8deg) scale(0.98); }
            40% { transform: rotate(-6deg) scale(1.03); }
            60% { transform: rotate(6deg) scale(0.97); }
            80% { transform: rotate(-4deg) scale(1.01); }
          }
          .jiggle {
            animation: jiggle 1.0s infinite;
          }
          @keyframes fadeSlideUp {
            0% {
              opacity: 0;
              transform: translateY(30px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .fade-slide-up {
            animation: fadeSlideUp 1s ease-out;
          }
        `}
      </style>
      <div className='flex justify-center'>
        <img src="/piggy-usa.png" alt="Piggy Logo" className="w-36 h-36 mb-4 " />
        <img src="/Telegram_Icons.png" alt="Telegram Logo" className="w-36 h-36 mb-4 " />

      </div>
      
      <h1 className="text-4xl font-extrabold text-center mb-4 tracking-tight text-yellow-400 drop-shadow-lg">Connect Bot WeThaiInvest</h1>
      
    <div>
      <button
        onClick={() => login()}
        className="flex items-center bg-white text-gray-900 font-medium px-5 py-2 rounded-full shadow border border-gray-300 hover:bg-gray-100 transition-all"
        style={{ minWidth: 220 }}
      >
        <img
          src="/icons/Google_Icons.png"
          alt="Google Logo"
          className="w-6 h-6 mr-2"
        />
        <span className="text-base">Log in with Google</span>
      </button>
      <p className="my-8 text-xs text-gray-400">
        By logging in, you agree to our <a href="/privacy.html" className="underline text-yellow-400" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>.
      </p>
    </div>    
    </div>

  );
}
